{
  "dropdown": {
    "account": "Λογαριασμός",
    "signIn": "Είσοδος",
    "telekomIdTitle": "Telekom ID",
    "profileSettings": "Ρυθμίσεις Προφίλ",
    "signInWithAnother": "Είσοδος με άλλο λογαριασμό",
    "logout": "Έξοδος",
    "close": "Κλείσιμο"
  },
  "chatbot": {
    "welcome": "Καλώς ήρθες",
    "continueAs": "Συνέχισε ως ",
    "beginChatConnected": "Ξεκίνησε τη συνομιλία σου στο chat συνδεδεμένος<br/>με το <0>Telekom id {{telekomIdNumber}}</0>",
    "needConnectionRegistered": "Για να μπορέσω να σε εξυπηρετήσω για μια υφιστάμενη σύνδεση, θα χρειαστεί να την έχεις καταχωρήσει στις συνδέσεις που διαχειρίζεσαι. Αν θες να προσθέσεις τη σύνδεση σου, <0>εδώ</0>"
  }
}
